const isValidEmail = (email) => {
  const regex = /\S+@\S+/;
  if (regex.test(email)) {
    return true;
  }
  return false;
};

export default isValidEmail;
